import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import Heading from "../FormElements/Heading/Heading";
import TextField from "../FormElements/TextField/TextField";
import Paragraph from "../FormElements/Paragraph/Paragraph";
import Signature from "../FormElements/Signature/Signature";
import RadioSelection from "../FormElements/RadioSelection/RadioSelection";
import FileUpload from "../FormElements/FileUpload/FileUpload";
import DatePickerComponent from "../FormElements/DatePicker/DatePickerComponent";
import CheckboxComponent from "../FormElements/Checkbox/CheckboxComponent";
import HorizontalContainer from "../FormElements/HorizontalContainer/HorizontalContainer";
import LogoComponent from "../FormElements/Logo/LogoComponent";
import { useParams } from "react-router-dom";
import { fetchClientDetailData } from "../../utils/formUtils";
import BackgroundColorContext from "../../context/BackgroundColorContext";
import PageBreak from "../FormElements/PageBreak/PageBreak";
import { USERROLE } from "../../utils/commonConstant";

const FormElement = ({
  element,
  dragHandle,
  onClick,
  setSelectedElementId,
  border,
  onPropsChange,
  selectedElementId,
  formPreview,
  trackChangeDisplayBy = USERROLE.ADMIN,
  isShowTrackHistory = false,
  isPresentMode = false,
  isTour = false
}) => {
  const [logoScr, setLogoSrc] = useState();
  const { backgroundColor, setBackgroundColor } = useContext(
    BackgroundColorContext
  );
  const { clientId } = useParams();
  const clientDetail = async () => {
    const response = await fetchClientDetailData(clientId);
    setLogoSrc(response.LogoImageData);
    setBackgroundColor(response.BackgroundColour || "#f9c908");

    const backgroundColor = response.BackgroundColour || "#f9c908";
    const fontColor = response.HHHeadingFontColor || "#000000";
    let styleContent = `
    .hh-heading {
      background-color: ${backgroundColor} !important;
      color: ${fontColor} !important;
    }
    .hh-heading span {
      color: ${fontColor} !important;
    }
    .hh-heading-inline {
      background-color: ${backgroundColor} !important;
      color: ${fontColor} !important;
      width: 184.6mm;
      margin-left: -10mm;
      padding-left: 25mm;
    }
    .hh-heading-inline span {
      color: ${fontColor} !important;
      margin-left: -10mm;
    }
  `;

    const styleElement = document.createElement("style");
    styleElement.innerHTML = styleContent;
    document.head.appendChild(styleElement);

    return response;
  };
  // useEffect(() => {
  //   if ((element.type === "logo" || element.type==="paragraph"|| element.type==="heading")&&(!logoScr || backgroundColor)) {
  //     clientDetail();
  //   }
  // }, []);
  useEffect(() => {
    const isDisplayType = ["logo", "paragraph", "heading"].includes(
      element.type
    );
    const shouldFetchClientDetail =
      isDisplayType && (!logoScr || !backgroundColor) && !isTour;

    if (shouldFetchClientDetail) {
      clientDetail();
    }
  }, []);

  const renderElement = () => {
    switch (element.type) {
      case "heading":
        return border ? (
          <Heading
            {...element.props}
            elementId={element.id}
            border={border}
            elementProps={element.props}
            sx={{ width: element.props.width }}
            onTextChange={(
              text,
              comments,
              trackChangesComments,
              forceSave,
              trackHistorys
            ) =>
              onPropsChange({
                ...element.props,
                text,
                comments,
                trackChangesComments,
                forceSave,
                trackHistorys,
              })
            }
            onEditorInlineFieldsChange={(inlineFields) =>
              onPropsChange({ ...element.props, inlineFields })
            }
            selectedElementId={selectedElementId}
            formPreview={formPreview}
            trackChangeDisplayBy={trackChangeDisplayBy}
            isShowTrackHistory={isShowTrackHistory}
            isPresentMode={isPresentMode}
          />
        ) : (
          <Heading
            {...element.props}
            elementId={element.id}
            border={border}
            elementProps={element.props}
            sx={{ width: element.props.width }}
            onTextChange={(
              text,
              comments,
              trackChangesComments,
              forceSave,
              trackHistorys
            ) =>
              onPropsChange({
                ...element.props,
                text,
                comments,
                trackChangesComments,
                forceSave,
                trackHistorys,
              })
            }
            formPreview={formPreview}
            trackChangeDisplayBy={trackChangeDisplayBy}
            isShowTrackHistory={isShowTrackHistory}
            isPresentMode={isPresentMode}
          />
        );
      case "textField":
        return (
          <TextField
            {...element.props}
            elementId={element.id}
            sx={{ width: 225 }}
            border={border}
          />
        );
      case "paragraph":
        return border ? (
          <Paragraph
            {...element.props}
            elementId={element.id}
            border={border}
            elementProps={element.props}
            sx={{ width: element.props.width }}
            onTextChange={(
              text,
              comments,
              trackChangesComments,
              forceSave,
              trackHistorys
            ) =>
              onPropsChange({
                ...element.props,
                text,
                comments,
                trackChangesComments,
                forceSave: true,
                trackHistorys,
              })
            }
            onEditorInlineFieldsChange={(inlineFields) =>
              onPropsChange({ ...element.props, inlineFields })
            }
            selectedElementId={selectedElementId}
            formPreview={formPreview}
            trackChangeDisplayBy={trackChangeDisplayBy}
            isShowTrackHistory={isShowTrackHistory}
            isPresentMode={isPresentMode}
          />
        ) : (
          <Paragraph
            {...element.props}
            elementId={element.id}
            border={border}
            elementProps={element.props}
            sx={{ width: element.props.width }}
            onTextChange={(
              text,
              comments,
              trackChangesComments,
              forceSave,
              trackHistorys
            ) =>
              onPropsChange({
                ...element.props,
                text,
                comments,
                trackChangesComments,
                forceSave: true,
                trackHistorys,
              })
            }
            formPreview={formPreview}
            trackChangeDisplayBy={trackChangeDisplayBy}
            isShowTrackHistory={isShowTrackHistory}
            isPresentMode={isPresentMode}
          />
        );

      case "signature":
        return (
          <Signature
            {...element.props}
            elementId={element.id}
            sx={{ width: element.props.width }}
            border={border}
          />
        );
      case "radioSelection":
        return (
          <RadioSelection
            {...element.props}
            elementId={element.id}
            sx={{ width: element.props.width }}
            onChange={() => { }}
            border={border}
          />
        );
      case "fileUpload":
        return (
          <FileUpload
            {...element.props}
            elementId={element.id}
            sx={{ width: element.props.width }}
            border={border}
          />
        );
      case "datePicker":
        return (
          <DatePickerComponent
            {...element.props}
            elementId={element.id}
            sx={{ width: element.props.width }}
            border={border}
          />
        );
      case "checkBox":
        return (
          <CheckboxComponent
            {...element.props}
            elementId={element.id}
            sx={{ width: element.props.width }}
            border={border}
          />
        );
      case "horizontalContainer":
        return (
          <HorizontalContainer
            {...element.props}
            dragHandle={dragHandle}
            elementId={element.id}
            sx={{ width: element.props.width }}
            items={element.items}
            setSelectedElementId={setSelectedElementId}
            border={border}
            formPreview={formPreview}
            isPresentMode={isPresentMode}
          />
        );
      case "logo":
        return (
          <LogoComponent
            {...element.props}
            base64Src={logoScr}
            elementId={element.id}
            sx={{ width: element.props.width }}
            onResizeLogo={(height, width, marginTop, marginLeft) =>
              onPropsChange({
                ...element.props,
                height,
                width,
                marginTop,
                marginLeft,
              })
            }
            border={border}
          />
        );
      case "pageBreak":
        return <PageBreak {...element.props} elementId={element.id} />;
      default:
        return <div>Unknown element type</div>;
    }
  };

  return <div>{renderElement()}</div>;
};

FormElement.propTypes = {
  element: PropTypes.object.isRequired,
};

export default FormElement;
